module.exports = __webpack_public_path__ + "static/media/ski-jump.30bc9bf7.svg";